import { SOMETHING_WENT_WRONG } from "@Services/constants";
import { XmlToJson, convertXmlDataToTasks } from "./XmlUtils";
import _ from "lodash";

export const convertP6XmlToJson = (data, scheduleId) => {
  const json = XmlToJson(data);
  if (typeof json == "object") {
    try {
      const RelationshipConvert = {
        "Finish to Start": "FS",
        "Finish to Finish": "FF",
        "Start to Finish": "SF",
        "Start to Start": "SS",
      };

      const ObjectIdAndIndexmapper = {};
      const IDAndIndexMapper = {};
      let ctr = 0;

      const jsdata = json.APIBusinessObjects;
      const customData = {
        Activity: jsdata.Project.Activity,
        WBS: jsdata.Project.WBS,
        Relationship: jsdata.Project.Relationship,
        BaselineActivity: jsdata.BaselineProject.Activity,
      };

      const projectCode = jsdata.Project.Id;
      const projectCalendar = _.get(jsdata, "Project.Calendar", []);
      const xmlCalendar = _.get(jsdata, "Calendar", []);
      const projectCalendarArray = Array.isArray(projectCalendar) ? projectCalendar : [projectCalendar];
      const calendarArray = Array.isArray(xmlCalendar) ? xmlCalendar : [xmlCalendar];
      const mergedCalendar = [...projectCalendarArray, ...calendarArray];

      customData.Calendar = mergedCalendar;

      const tempArray = [];

      const hoursPerday = customData.Calendar[0].HoursPerDay;
      customData.Activity.map((element) => {
        tempArray.push({
          TaskId: String(element.Id),
          TaskName: element.Name,
          // Duration: element.ActualDuration || '',
          Duration: "",
          Start: element.StartDate ? element.StartDate : "",
          Finish: element.FinishDate ? element.FinishDate : "",
          WBSPath: String(element.WBSObjectId) || "",
          PredecessorDetails: "",
          Successor: "",
          Predecessor: "",
          ActualStart: typeof element.ActualStartDate != "object" ? element.ActualStartDate : "",
          ActualFinish: typeof element.ActualFinishDate != "object" ? element.ActualFinishDate : "",
          Progress: element.PhysicalPercentComplete * 100,
        });
        ObjectIdAndIndexmapper[element.ObjectId] = ctr;
        IDAndIndexMapper[element.Id] = ctr;
        ctr += 1;
      });

      customData.BaselineActivity.map((element) => {
        if (tempArray[IDAndIndexMapper[element.Id]]) {
          tempArray[IDAndIndexMapper[element.Id]].PlannedStart =
            typeof element.PlannedStartDate != "object" ? element.PlannedStartDate : "";
          tempArray[IDAndIndexMapper[element.Id]].PlannedFinish =
            typeof element.PlannedFinishDate != "object" ? element.PlannedFinishDate : "";
        }
      });

      customData.WBS.map((element) => {
        let WBSCode = "";
        if (typeof element.ParentObjectId == "object") {
          WBSCode = `${projectCode}.${String(element.Code)}`;
        } else {
          WBSCode = `${tempArray[ObjectIdAndIndexmapper[element.ParentObjectId]].WBSCode}.${String(element.Code)}`;
        }
        tempArray.push({
          TaskId: String(element.ObjectId),
          TaskName: element.Name,
          WBSPath: typeof element.ParentObjectId != "object" ? String(element.ParentObjectId) : "",
          WBSCode,
        });
        ObjectIdAndIndexmapper[element.ObjectId] = ctr;
        ctr += 1;
      });

      customData.Relationship.map((element) => {
        const successorIndex = ObjectIdAndIndexmapper[element.SuccessorActivityObjectId];
        const predIndex = ObjectIdAndIndexmapper[element.PredecessorActivityObjectId];
        let content;
        if (tempArray[successorIndex].PredecessorDetails == "") {
          content = `${predIndex + 1}${RelationshipConvert[element.Type]}${
            element.Lag != 0 ? `${element.Lag > 0 ? "+" : ""}${element.Lag / hoursPerday} days` : ""
          }`;
        } else {
          content = `${tempArray[successorIndex].PredecessorDetails},${predIndex + 1}${
            RelationshipConvert[element.Type]
          }${element.Lag ? `${element.Lag > 0 ? "+" : ""}${element.Lag / hoursPerday} days` : ""}`;
        }
        tempArray[successorIndex].PredecessorDetails = content;
      });

      return {
        calendar: customData.Calendar,
        data: convertXmlDataToTasks(tempArray, scheduleId),
      };
    } catch (e) {
      console.log(e);
      return SOMETHING_WENT_WRONG;
    }
  } else {
    return json;
  }
};
